(() => {
  if (window.mavoliraPhotoWallMounted) return;
  window.mavoliraPhotoWallMounted = true;
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const rail = root.querySelector('.ms-photo-wall-rail');
    const originals = [...rail.children];
    if (!originals.length) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const { signal } = controller;
    let frame = 0, last = 0, position = 0, cycle = 0, visible = false;
    let paused = false, hovered = false, focused = false, touching = false, resumeAt = 0;
    const removeCopies = () => rail.querySelectorAll('[data-photo-copy]').forEach(el => el.remove());
    function resize() {
      removeCopies();
      cycle = originals[0].getBoundingClientRect().width * originals.length;
      if (!cycle) return;
      if (!reduced.matches) {
        const copies = Math.ceil(rail.clientWidth / cycle) + 1;
        for (let group = 0; group < copies; group++) {
          for (const original of originals) {
            const copy = original.cloneNode(true);
            copy.dataset.photoCopy = '';
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-shopify-editor-block');
            copy.removeAttribute('id');
            copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
            copy.querySelectorAll('a').forEach(el => el.tabIndex = -1);
            rail.append(copy);
          }
        }
      }
      root.classList.toggle('is-looping', !reduced.matches);
      position = reduced.matches ? 0 : position % cycle;
      rail.scrollLeft = position;
      schedule();
    }
    function schedule() {
      cancelAnimationFrame(frame);
      last = 0;
      if (visible && !document.hidden && !reduced.matches && !paused && !hovered && !focused && !touching && cycle) {
        frame = requestAnimationFrame(tick);
      }
    }
    function tick(now) {
      if (now < resumeAt) {
        position = rail.scrollLeft;
        last = now;
      } else {
        const delta = last ? Math.min(now - last, 50) : 0;
        position = (position + delta * .028) % cycle;
        rail.scrollLeft = position;
        last = now;
      }
      frame = requestAnimationFrame(tick);
    }
    function manual() {
      position = rail.scrollLeft;
      resumeAt = performance.now() + 1800;
    }
    rail.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse') { hovered = true; schedule(); }
    }, { signal });
    rail.addEventListener('pointerleave', () => { hovered = false; schedule(); }, { signal });
    rail.addEventListener('focusin', () => { focused = true; schedule(); }, { signal });
    rail.addEventListener('focusout', event => { focused = rail.contains(event.relatedTarget); manual(); schedule(); }, { signal });
    rail.addEventListener('pointerdown', () => { touching = true; schedule(); }, { signal });
    const release = () => { if (touching) { touching = false; manual(); schedule(); } };
    window.addEventListener('pointerup', release, { signal });
    window.addEventListener('pointercancel', release, { signal });
    rail.addEventListener('wheel', manual, { passive: true, signal });
    rail.addEventListener('scroll', () => {
      if (touching || hovered || focused || paused) manual();
    }, { passive: true, signal });
    document.addEventListener('visibilitychange', schedule, { signal });
    reduced.addEventListener('change', resize, { signal });
    root.addEventListener('shopify:block:select', event => {
      paused = true;
      const index = originals.findIndex(el => el === event.target || el.contains(event.target));
      if (index >= 0) rail.scrollLeft = index * originals[0].getBoundingClientRect().width;
      schedule();
    }, { signal });
    const resizeObserver = new ResizeObserver(resize);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
    resize();
    resizeObserver.observe(rail);
    observer.observe(root);
    instances.set(root, () => {
      controller.abort();
      cancelAnimationFrame(frame);
      resizeObserver.disconnect();
      observer.disconnect();
      removeCopies();
      root.classList.remove('is-looping');
    });
  }
  const start = () => document.querySelectorAll('[data-ms-photo-wall]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
})();
